import styled from "styled-components";
/* #region STYLED CSS */
const StyledButton = styled.div`
    &.main-button {
        border-radius: 10px;
        border-style: solid;
        border-color: var(--salmon, #f7665f);
        border-width: 1px;
        padding: 10px 16px 10px 16px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 176px;
        height: 48px;
        position: relative;
        cursor: pointer;
        z-index: 0;
    }
    &.heybo-border-animation:before {
        content: "";
        background: linear-gradient(45deg, #7745e0, #68efcf, #5ac3fe, #5ac3fe, #68efcf, #7745e0);
        position: absolute;
        top: -2px;
        left: -2px;
        background-size: 400%;
        z-index: -1;
        filter: blur(5px);
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        animation: glowing 10s linear infinite;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        border-radius: 10px;
    }

    &.heybo-border-animation:hover:before {
        opacity: 1;
    }

    &.heybo-border-animation:after {
        z-index: -1;
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgb(5, 5, 5);
        left: 0;
        top: 0;
        border-radius: 10px;
    }
    .ask-hey-bo-with-icon {
        font-family: "ItcAvantGardeGothicProMd-Regular", sans-serif !important;
        font-size: 14px !important;
        font-weight: 400 !important;
    }
    .ask-hey-bo {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: "ITC Avant Garde Gothic";
        font-size: 16px;
        line-height: 16.68px;
        font-weight: 100;
        position: relative;
        width: 146px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    @keyframes glowing {
        0% {
            background-position: 0 0;
        }
        50% {
            background-position: 400% 0;
        }
        100% {
            background-position: 0 0;
        }
    }
    @media (max-width: 768px) {
        &.main-button {
            height: 40px;
            width: 130px;
            padding: 10px 10px;
        }
        .ask-hey-bo {
            font-size: 12px;
        }
    }
`;
/* #endregion STYLED CSS */
export default function ButtonSM({
    title = "--",
    borderColor = "#f7665f",
    icon,
    useHeyBOBorderAnimation = false,
    disabled = false,
    onClick,
    className = "",
    style = {}
}) {
    /* #region METHODS */
    const handleClick = e => {
        if (!disabled && onClick) {
            onClick(e);
        }
    };
    /* #endregion METHODS */
    return (
        <StyledButton
            onClick={handleClick}
            className={`main-button ${className} ${useHeyBOBorderAnimation ? "heybo-border-animation" : ""}`}
            style={{
                ...style,
                borderColor: borderColor,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1
            }}>
            {icon && <img src={icon} alt={icon} />}
            <span className={`ask-hey-bo ${icon ? "ask-hey-bo-with-icon" : ""}`}>{title}</span>
        </StyledButton>
    );
}
